module.exports = __webpack_public_path__ + "img/search terms.f48b6c5e.png";